import { Buffer } from 'buffer';
// import stream from 'stream-browserify';

window.global = window.global ?? window;
window.Buffer = window.Buffer ?? Buffer;
window.process = window.process ?? { env: {} }; // Minimal process polyfill
// window.Stream = window.Stream ?? stream;

export {};
